import { setupPwa } from './pwa.ts';
import '@fontsource/fraunces/latin-600.css';
import '@fontsource/fraunces/latin-800.css';
import '@fontsource/atkinson-hyperlegible/latin-400.css';
import '@fontsource/atkinson-hyperlegible/latin-700.css';
import '@fontsource/caveat/latin-600.css';
import './ui/theme.css';
import { mount } from 'svelte';
import App from './ui/App.svelte';
import { fetchChapter } from './game/game.ts';
import { audio } from './audio/audio.ts';
import { showCaption } from './ui/captions.ts';
import './settings.ts';

{
  const qp = new URLSearchParams(location.search);
  if (!location.pathname.startsWith('/editor')) fetchChapter(qp.get('chapter') ?? 'ch1', qp.get('draft') === '1');
}

// Audio darf erst nach einer Nutzergeste starten
const unlock = () => audio.unlock();
window.addEventListener('pointerdown', unlock);
window.addEventListener('keydown', unlock);
audio.onCaption = (text) => showCaption(text);

setupPwa();
mount(App, { target: document.getElementById('app')! });
